import ms from './../enums/system.js';

const systemsDefault = [
    ms.CUSTOM,
    ms.EUROPEAN,
    ms.HYBRID,
    ms.IMPERIAL,
    ms.METRIC,
    ms.SI
];

export default systemsDefault;